import { isValidHttpUrl } from '@lib/utils/strings'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { showComments } from '@storeOld/reducers/comments'
import cx from 'classnames'
import type React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { isFigmaUrl } from '@/helpers'
import type { AppState } from '@/types'
import { IconExternalLink } from '../../../../../../icons'
import css from './Siblings.module.scss'

type Props = {
  nodeId: string
  url: string
}

const Siblings: React.FC<Props> = ({ nodeId, url }) => {
  const dispatch = useDispatch()

  const validUrl = isValidHttpUrl(url) ? url : `https://${url}`

  const isFigma = isFigmaUrl(url)
  const isFigmaEnabled = useSelector(
    migrationProjectSelector.getProjectIsFigmaEnabled
  )

  // @todo implement later
  const comments = useSelector<AppState, number>(({ manager }) => {
    return manager.comments.filter((comment) => comment.commentable === nodeId)
      .length
  })

  const onClickComments = () => {
    // @todo implement action
    // @ts-expect-error
    dispatch(showComments(nodeId))
  }

  return (
    <div className={css.container}>
      {url && (!isFigma || !isFigmaEnabled) && (
        <a
          className={css.button}
          href={validUrl}
          target="_blank"
          rel="noopener nofollow"
        >
          <IconExternalLink />
        </a>
      )}

      {comments && comments > 0 && (
        <div
          className={cx(css.button, {
            [css.twoDigits]: comments && comments > 9,
          })}
          onClick={onClickComments}
        >
          <div>{comments}</div>
        </div>
      )}
    </div>
  )
}

export default Siblings
